// libs
import styled from 'styled-components'
// components
import Tabs from '@mui/material/Tabs'
// themes
import { colors } from 'themes'

export default styled(Tabs)`
  && {
    border-bottom: 1px solid ${colors.gray300};

    button {
      min-width: 120px;
    }
  }
` as typeof Tabs
